export const ROLLOUT_WORKFLOW_ID = 'rollout';

// Maximum treatment reach percentage (0.9 = 90%). 10% is reserved for the control group.
export const MAX_TREATMENT_REACH = 0.9;

// Default initial reach as a percentage string (1%).
export const DEFAULT_INITIAL_REACH = '1';
